mutation UpdateAgentPushConfig(
  $agentRegistrationId: ID!
  $pushMode: String
  $pushFolderName: String
) {
  updateAgentPushConfig(
    input: {
      agentRegistrationId: $agentRegistrationId
      pushMode: $pushMode
      pushFolderName: $pushFolderName
    }
  ) {
    agentRegistration {
      id
      pushMode
      pushFolderName
    }
    errors
  }
}
